import { Component, inject, OnInit } from "@angular/core";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { Router, RouterLink } from "@angular/router";
import { ApiService } from "../../../../../../../shared/src";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ChangePasswordComponent } from "../../../../pages/user-pages/change-password/change-password.component";
import { LanguageSelectorComponent } from "../../../../pages/user-pages/language-selector/language-selector.component";
import { SupportChannelService } from "../../../../../../../shared/src/lib/services/support-channel.service";
import { QrDialogComponent } from "../../../../components/support-widget/qr-dialog/qr-dialog.component";

@Component({
  selector: "app-user-button",
  imports: [RouterLink, MatMenuModule, MatIconModule, MatButtonModule, TranslateModule],
  templateUrl: "./user-button.component.html",
  styleUrl: "./user-button.component.scss",
})
export class UserButtonComponent implements OnInit {
  apiService = inject(ApiService);
  navService = inject(NavService);
  router = inject(Router);
  bottomSheet = inject(MatBottomSheet);
  dialog = inject(MatDialog);
  readonly supportChannelService = inject(SupportChannelService);
  user: any = null;

  get userName() {
    const user = this.apiService.getUserToken();
    return user?.user?.NAME;
  }

  ngOnInit() {
    const app = this.apiService.getUserToken();
    this.user = app.user;
    this.supportChannelService.fetch();
  }

  openQr(qrLink: string, channelName: string, channelType: 'whatsapp' | 'telegram', webLink: string): void {
    this.dialog.open(QrDialogComponent, {
      data: { qrLink, channelName, channelType, webLink },
      width: "340px",
    });
  }

  canShowItem(item: any): boolean {
    if (item.name === "Change Password") {
      return !this.userName.includes("demo");
    }
    return true;
  }

  handleNonRouteItems(name: string) {
    if (name === "Change Password") {
      this.handleChangePassword();
    } else if (name === "Select Language") {
      this.handleSelectLanguage();
    } else if (name === "Sign Out") {
      this.apiService.handleSignOut();
    }
  }

  handleSelectLanguage() {
    this.bottomSheet.open(LanguageSelectorComponent);
  }

  handleChangePassword() {
    this.bottomSheet
      .open(ChangePasswordComponent)
      .afterDismissed()
      .subscribe((result) => {
        if (result) this.apiService.handleSignOut();
      });
  }
}
